import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import api from '../services/api';
import NoticiaImage from '../components/NoticiaImage';
import { getImageByIndex } from '../utils/exampleImages';
import { formatarFechaLocal, convocatoriaCerrada } from '../utils/fileUtils';
import Breadcrumbs from '../components/Breadcrumbs';
import { FaStar } from 'react-icons/fa';
import './Convocatorias.css';

const stripHtml = (html) => {
  if (!html || typeof html !== 'string') return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

const esCerrada = convocatoriaCerrada;

const Convocatorias = () => {
  const { data: convocatoriasRaw = [], isLoading } = useQuery({
    queryKey: ['convocatorias'],
    queryFn: async () => {
      const response = await api.get('/convocatorias');
      return response.data;
    }
  });

  const sinDuplicados = convocatoriasRaw.filter(
    (c, i, arr) => arr.findIndex((x) => (x.titulo || '').trim() === (c.titulo || '').trim()) === i
  );
  const convocatorias = [...sinDuplicados].sort((a, b) => {
    const aCerrada = esCerrada(a);
    const bCerrada = esCerrada(b);
    if (aCerrada === bCerrada) return 0;
    return aCerrada ? 1 : -1;
  });

  if (isLoading) {
    return (
      <div className="convocatorias-page">
        <div className="convocatorias-inner">
          <div className="loading">Cargando convocatorias...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="convocatorias-page">
      <div className="convocatorias-inner">
        <Breadcrumbs />
        <section className="convocatorias-section">
          <h1 className="convocatorias-title">Convocatorias</h1>

          {convocatorias.length === 0 ? (
            <div className="convocatorias-empty">
              <p>No hay convocatorias disponibles en este momento.</p>
            </div>
          ) : (
            <div className="convocatorias-grid">
              {convocatorias.map((convocatoria, index) => {
                const descripcionLimpia = stripHtml(convocatoria.descripcion || '').replace(/\b2025\b/g, '2026');
                return (
                  <article key={convocatoria.id} className="convocatoria-card">
                    <div className="convocatoria-card-image-wrap">
                      <NoticiaImage
                        src={convocatoria.imagen_url || getImageByIndex(index, 'eventos')}
                        alt={convocatoria.titulo}
                        className="convocatoria-card-image"
                      />
                      <div className="convocatoria-card-badges">
                        {esCerrada(convocatoria) && (
                          <span className="convocatoria-badge convocatoria-badge-cerrada">Cerrada</span>
                        )}
                        {convocatoria.destacada && !esCerrada(convocatoria) && (
                          <span className="convocatoria-badge convocatoria-badge-destacada">
                            <FaStar /> Destacada
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="convocatoria-card-body">
                      <h2>{convocatoria.titulo}</h2>
                      <p>{descripcionLimpia.substring(0, 200)}{descripcionLimpia.length > 200 ? '...' : ''}</p>
                      <div className="convocatoria-fechas">
                        <p><strong>Inicio:</strong> {formatarFechaLocal(convocatoria.fecha_inicio, { day: 'numeric', month: 'short', year: 'numeric' })}</p>
                        <p><strong>Fin:</strong> {convocatoria.fecha_fin ? formatarFechaLocal(convocatoria.fecha_fin, { day: 'numeric', month: 'short', year: 'numeric' }) : '-'}</p>
                        {(convocatoria.actualizado_en || convocatoria.fecha_actualizacion) && (
                          <p className="convocatoria-actualizacion">
                            <strong>Última actualización:</strong>{' '}
                            {new Date(convocatoria.actualizado_en || convocatoria.fecha_actualizacion).toLocaleDateString('es-CO', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            })}
                          </p>
                        )}
                      </div>
                      <Link to={`/convocatorias/${convocatoria.id}`} className="convocatoria-card-btn">
                        Ver detalles →
                      </Link>
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default Convocatorias;
